import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';
import styles from './Navbar.module.scss';
import logoImg from '../../assets/tutomart-logo.jpeg';
import { USER_NAVBAR_STRINGS, COMMON } from '../../constants/appConstants';
import { USER_ROUTES } from '../../constants/routeConstants';
import { Home, Ticket, User, Clock, LogOut, Menu, X } from 'lucide-react';

const Navbar = () => {
  const auth = useAuth() || {};
  const user = auth.user || null;
  const logout = auth.logout || (() => Promise.resolve());
  const location = useLocation();
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  const handleLogout = async () => {
    await logout();
    setIsMobileMenuOpen(false);
  };

  const toggleMobileMenu = () => {
    setIsMobileMenuOpen(!isMobileMenuOpen);
  };

  const closeMobileMenu = () => {
    setIsMobileMenuOpen(false);
  };

  return (
    <nav className={styles['nav-premiumNavbar']}>
      <div className={styles['nav-container']}>
        {/* Logo */}
        <Link className={styles['nav-brand']} to={USER_ROUTES.DASHBOARD} onClick={closeMobileMenu}>
          <img 
            src={logoImg} 
            alt={COMMON.BRAND_NAME} 
            className={styles['nav-logo']}
          />
          <span className={styles['nav-brandName']}>{COMMON.BRAND_NAME}</span>
        </Link>

        {/* Desktop Navigation - Right Side */}
        <div className={styles['nav-desktop']}>
          <div className={styles['nav-links']}>
            <Link 
              className={`${styles['nav-link']} ${location.pathname === USER_ROUTES.DASHBOARD ? styles['nav-active'] : ''}`}
              to={USER_ROUTES.DASHBOARD}
            >
              <Home size={15} />
              <span>{USER_NAVBAR_STRINGS.NAV.DASHBOARD}</span>
            </Link>
            
            <Link 
              className={`${styles['nav-link']} ${location.pathname === USER_ROUTES.SUPPORT ? styles['nav-active'] : ''}`}
              to={USER_ROUTES.SUPPORT}
            >
              <Ticket size={15} />
              <span>{USER_NAVBAR_STRINGS.NAV.SUPPORT}</span>
            </Link>
            
            <Link 
              className={`${styles['nav-link']} ${location.pathname === USER_ROUTES.HISTORY ? styles['nav-active'] : ''}`}
              to={USER_ROUTES.HISTORY}
            >
              <Clock size={15} />
              <span>{USER_NAVBAR_STRINGS.NAV.HISTORY}</span>
            </Link>
            
            <Link 
              className={`${styles['nav-link']} ${location.pathname === USER_ROUTES.PROFILE ? styles['nav-active'] : ''}`}
              to={USER_ROUTES.PROFILE}
            >
              <User size={15} />
              <span>{USER_NAVBAR_STRINGS.NAV.PROFILE}</span>
            </Link>
            
            <button 
              className={`${styles['nav-logoutBtn']}`}
              onClick={handleLogout}
            >
              <LogOut size={15} />
              <span>{USER_NAVBAR_STRINGS.NAV.LOGOUT}</span>
            </button>
          </div>
        </div>

        {/* Mobile Menu Button */}
        <button 
          className={`${styles['nav-mobileMenuBtn']} ${isMobileMenuOpen ? styles['nav-active'] : ''}`}
          onClick={toggleMobileMenu}
          aria-label="Toggle menu"
        >
          {isMobileMenuOpen ? <X size={20} /> : <Menu size={20} />}
        </button>

        {/* Mobile Navigation */}
        <div className={`${styles['nav-mobile']} ${isMobileMenuOpen ? styles['nav-active'] : ''}`}>
          <div className={styles['nav-mobileUserInfo']}>
            <div className={styles['nav-userAvatar']}>
              {user?.name?.charAt(0).toUpperCase()}
            </div>
            <div className={styles['nav-userDetails']}>
              <div className={styles['nav-userNameMobile']}>{user?.name}</div>
              <div className={styles['nav-userEmail']}>{user?.email}</div>
            </div>
          </div>

          <div className={styles['nav-mobileNavLinks']}>
            <Link 
              className={`${styles['nav-mobileNavLink']} ${location.pathname === USER_ROUTES.DASHBOARD ? styles['nav-active'] : ''}`}
              to={USER_ROUTES.DASHBOARD}
              onClick={closeMobileMenu}
            >
              <Home size={16} />
              <span>{USER_NAVBAR_STRINGS.NAV.DASHBOARD}</span>
              <div className={styles['nav-linkIndicator']}></div>
            </Link>
            
            <Link 
              className={`${styles['nav-mobileNavLink']} ${location.pathname === USER_ROUTES.SUPPORT ? styles['nav-active'] : ''}`}
              to={USER_ROUTES.SUPPORT}
              onClick={closeMobileMenu}
            >
              <Ticket size={16} />
              <span>{USER_NAVBAR_STRINGS.NAV.SUPPORT}</span>
              <div className={styles['nav-linkIndicator']}></div>
            </Link>
            
            <Link 
              className={`${styles['nav-mobileNavLink']} ${location.pathname === USER_ROUTES.PROFILE ? styles['nav-active'] : ''}`}
              to={USER_ROUTES.PROFILE}
              onClick={closeMobileMenu}
            >
              <User size={16} />
              <span>{USER_NAVBAR_STRINGS.NAV.PROFILE}</span>
              <div className={styles['nav-linkIndicator']}></div>
            </Link>
            
            <Link 
              className={`${styles['nav-mobileNavLink']} ${location.pathname === USER_ROUTES.HISTORY ? styles['nav-active'] : ''}`}
              to={USER_ROUTES.HISTORY}
              onClick={closeMobileMenu}
            >
              <Clock size={16} />
              <span>{USER_NAVBAR_STRINGS.NAV.HISTORY}</span>
              <div className={styles['nav-linkIndicator']}></div>
            </Link>

            <button 
              className={`${styles['nav-mobileNavLink']} ${styles['nav-logoutBtn']}`}
              onClick={handleLogout}
            >
              <LogOut size={16} />
              <span>{USER_NAVBAR_STRINGS.NAV.LOGOUT}</span>
              <div className={styles['nav-linkIndicator']}></div>
            </button>
          </div>
        </div>

        {/* Mobile Overlay */}
        {isMobileMenuOpen && (
          <div className={styles['nav-mobileOverlay']} onClick={closeMobileMenu}></div>
        )}
      </div>
    </nav>
  );
};

export default Navbar;